import React from "react";
import { TextField } from "@material-ui/core";
import InputMask from "react-input-mask";
import "../InputText/index.scss";

export interface InputTextMaskProps {
    name?: string;
    value?: string;
    label?: string;
    mask?: string;
    maskChar?: string;
    toUpperCase?: boolean
    formatChars?: { [key: string]: string };
    alwaysShowMask?: boolean;
    placeholder?: string;
    helperText?: string;
    endAdornment?: React.ReactElement;
    beforeChange?: (value: any) => any;
    hidden?: boolean;
    disabled?: boolean;
    error?: boolean;
    validationError?: string;
    onChange?: (value: string) => void;
    formatResponse?: (obj: any) => string;
    listenerDependency?: any
}

export const InputTextMask = (props: InputTextMaskProps) => {
    const {
        value,
        name,
        toUpperCase,
        mask,
        maskChar,
        alwaysShowMask,
        formatChars,
        label,
        helperText,
        placeholder,
        endAdornment,
        hidden,
        disabled,
        error,
        validationError,
        beforeChange,
        onChange,
        formatResponse,
        ...rest
    } = props;

    const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        let val = event.target.value;
        let cleanValue = val.toString().replace(new RegExp(/([+()\- ])/gi), "");

        if (toUpperCase) cleanValue = cleanValue.toUpperCase();

        if (beforeChange) {
            cleanValue = beforeChange(cleanValue);
        }

        let formattedValue = formatResponse ? formatResponse(cleanValue) : cleanValue;

        if (onChange) onChange(formattedValue)
    };

    return (
        <div className={'input-text'} hidden={hidden}>
            <InputMask
                autoComplete="off"
                id={name}
                mask={mask ? mask : "******************************"}
                maskChar={maskChar ? maskChar : ""}
                alwaysShowMask={alwaysShowMask ? alwaysShowMask : false}
                value={value ?? ""}
                formatChars={formatChars || {
                    "9": "[0-9]",
                    "a": "[A-ZА-ЯІa-zа-яі]",
                    "*": "[A-ZА-ЯІa-zа-яі0-9]",
                    "_": "[0-9]"
                }}
                disabled={disabled}
                onChange={handleChange}
                placeholder="+38(0__)___-__-__"
                {...rest}
            >
                {
                    //@ts-ignore
                    (params: any) => (
                        <TextField {...params}
                            error={error}
                            fullWidth={true}
                            helperText={(error && validationError) || helperText}
                            InputLabelProps={{
                               style: {
                                   textOverflow: 'ellipsis',
                                   whiteSpace: 'nowrap',
                                   overflow: 'hidden',
                                   width: '92%'
                               },
                               shrink: Boolean(placeholder) || undefined,
                               position: "top",
                            }}
                            value={value ?? ""}
                            variant="outlined"
                            label={label}
                            placeholder={placeholder ? placeholder : ""}
                            InputProps={{
                               ...params.InputProps,
                               shrink: "true",
                               endAdornment: endAdornment
                            }}
                        />
                    )
                }
            </InputMask>
        </div>
    )
};